export const QUERY_MID = 'mid';
export const QUERY_CHARGEBACK_REF_NUM = 'refNum';
export const QUERY_CHARGEBACK_CASE_NUM = 'caseNumber';
